export default "__VITE_ASSET__DF4BFP6Z__"